<template>
    <div>
        <!-- 编辑、添加界面 -->
        <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="900px" :destroy-on-close="true"
            :before-close="cancel">
           <div class="el-dialog-div">
                <el-form label-width="120px" ref="form" :model="form" class="el-dialog-div">
                    <div style="width: 100%">
                        <div style="display: flex;align-items: center"
                            v-for="(pendingInfo, index) in form.pendingInfos">
                            <div style="display: flex;flex-wrap:wrap;width: 97%;" class="payment-box">
                                <el-form-item label="付款单位" :prop="'pendingInfos.' + index + '.invoiceTitle'"
                                    :rules="{ required: true, message: '请输入付款单位', trigger: 'change' }">
                                    <el-input v-model="pendingInfo.invoiceTitle" placeholder="请输入付款单位"></el-input>
                                </el-form-item>
                                <el-form-item label="收款单位" :prop="'pendingInfos.' + index + '.receivingUnitId'"
                                    :rules="[{ required: true, message: '请输入收款单位', trigger: 'change' }]">
                                    <el-select v-model="pendingInfo.receivingUnitId" style="width: 100%!important;"
                                        filterable placeholder="请输入收款单位">
                                        <el-option v-for="(item, index) in businessOption" :key="index"
                                            :label="item.companyName" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="到款金额" :prop="'pendingInfos.' + index + '.paymentAmount'" :rules="[{ required: true, message: '请输入到款金额', trigger: 'change' },
                                { validator: checkNum, trigger: 'change' }]">
                                    <el-input v-model="pendingInfo.paymentAmount" placeholder="请输入到款金额"></el-input>
                                </el-form-item>
                                <el-form-item label="到款日期" :prop="'pendingInfos.' + index + '.paymentDate'" :rules="[
                                    { required: true, message: '请选择到款时间', trigger: 'change' },
                                    { validator: checkDate, trigger: 'change' }]">
                                    <el-input size="medium" v-model="pendingInfo.paymentDate" auto-complete="off"
                                        placeholder="请输入日期，格式yyyy-MM-dd"></el-input>
                                </el-form-item>
                                <el-form-item label="到款备注" :prop="'pendingInfos.' + index + '.remark'"
                                    style="width: 96%!important;">
                                    <el-input :autosize="{ minRows: 3 }" type="textarea" maxlength="300" show-word-limit
                                        v-model="pendingInfo.remark" placeholder="请输入备注"></el-input>
                                </el-form-item>
                            </div>

                            <div v-if="type === 'add'"
                                style="justify-content: center;display: flex;flex-wrap: wrap;margin-left: 10px;width: 50px;margin-right: 10px;">
                                <el-button v-if="type === 'add'" type="danger" size="mini" icon="el-icon-delete"
                                    @click="handleDelete(index)" style="margin-bottom: 2px;"></el-button>
                                <el-button v-if="type === 'add' && index === form.pendingInfos.length - 1"
                                    type="success" size="mini" style="margin: 1px 0 0;" icon="el-icon-plus"
                                    @click="handleAdd"></el-button>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
   
            <div slot="footer" class="dialog-footer" v-if="type !== 'delete'">
                <el-button size="small" @click="cancel">取消</el-button>
                <el-button size="small" type="primary" class="title" @click="handle">提交</el-button>
            </div>
        </el-dialog>
        <loading :loading="dataLoading" load-text="数据加载中"></loading>
    </div>
</template>

<script>


import { addPendingPayment, editPendingPayment } from "@/api/dilivery/pending-payment";
import { checkDate, checkNum } from "@/utils/rules";
import { padDate } from "@/store/date";
import { getCompanyPage } from "@/api/dilivery/company";
import { getDataInLocalStorage } from "@/utils/localStorage";
import Loading from "@/components/loading/Loading.vue";

export default {
    name: "BatchAddPendingPayment",
    components: {
        Loading
    },
    props: {
        showDialog: {
            default: false
        },
        type: {
            default: ''
        },
        selectDetail: {
            default: () => ([])
        }
    },
    data() {
        return {
            role: '',
            title: '添加待认领信息',
            dataLoading: false,
            form: {
                pendingInfos: [],
            },
            businessOption: [],
        }
    },
    created() {
        this.role = getDataInLocalStorage('role')
    },
    watch: {
        type: {
            handler(newVal) {
                if (newVal) {
                    if (newVal === 'add') {
                        this.title = '添加到款信息'
                    } else {
                        this.title = '编辑到款信息'
                    }
                }
            },
            immediate: true
        }
    },
    mounted() {
        this.dataLoading = true
        if (this.type === 'add') {
            this.handleAdd()
        } else {
            this.form.pendingInfos = this.selectDetail.map(item => item)
        } 
        this.getBusinessOption()
    },
    methods: {
        checkNum,
        checkDate,
        handleAdd() {
            let form = {
                invoiceTitle: '',
                receivingUnitId: '',
                paymentAmount: '',
                paymentDate: this.getCurrentDate(),
                remark: ''
            }
            this.form.pendingInfos.push(form)
        },
        getCurrentDate() {
            const date = new Date();
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从 0 开始, September == 8
            const day = date.getDate().toString().padStart(2, '0'); // 日期
            return `${year}-${month}-${day}`
        },
        getBusinessOption() {
            try {
                let params = {
                    'page.current': 1,
                    'page.size': 500,
                    'order': 'id.asc'
                }
                getCompanyPage(params, {}).then(res => {
                    if (res.code === 200) {
                        this.businessOption = res.data.records
                    }
                }).finally(() => {
                    this.dataLoading = false
                })
            } catch (error) {
                console.log(error);
                this.dataLoading = false
            }
        },
        handleDelete(index) {
            this.form.pendingInfos.splice(index, 1);
            if (this.form.pendingInfos.length <= 0 || !Array.isArray(this.form.pendingInfos)) {
                this.form.pendingInfos = [{
                    invoiceTitle: '',
                    paymentAmount: '',
                    paymentDate: this.getCurrentDate(),
                    remark: ''
                }]
            }
        },
        cancel() {
            this.$emit('submit', 'cancel')
        },
        handle() {
            if (this.form.pendingInfos.length !== 0) {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        this.form.pendingInfos.forEach(item => {
                            item.paymentDate = padDate(item.paymentDate)
                        })
                        if (this.type === 'edit') {
                            editPendingPayment(this.form.pendingInfos).then(res => {
                                if (res.code === 200) {
                                    this.$emit('submit', 'confirm')
                                    this.$messageUi.success('修改成功')
                                    this.$store.commit('right/setChangeRed', true)
                                }
                            }).catch(err => {
                            })
                        } else {
                            addPendingPayment(this.form.pendingInfos).then(res => {
                                if (res.code === 200) {
                                    this.$emit('submit', 'confirm')
                                    this.$messageUi.success('提交成功')
                                    this.$store.commit('right/setChangeRed', true)
                                }
                            }).catch(err => {
                            })
                        }
                    } else {
                        this.$nextTick(() => {
                            let err = document.getElementsByClassName('is-error')
                            if (err.length) {
                                err[0].scrollIntoView({
                                    block: 'center',
                                    behavior: 'smooth',
                                })
                            }
                        })
                        this.$messageUi.error('填写参数不规范，请检查')
                    }
                })
            } else {
                this.$messageUi.error('请上传至少一条数据')
            }
        }
    },

}
</script>

<style lang="scss" scoped>
.payment-box {
    border: 1px dashed #ccc;
    /* 虚线框 */
    padding: 10px 10px 0 10px;
    /* 内边距 */
    margin: 10px 10px 0 0;
}

.payment-box:deep(.el-form-item) {
    width: 48% !important;
}
@import "@/assets/css/mixins.scss";

.el-dialog-div {
    @include thin-scrollbar(8px, #888);
    max-height: 60vh;
    /* 你还可以在这个类里写其他样式 */
    background: #fff;
}
</style>